import $ from "jquery";
import axios from "axios";

const state = {
  tourLevels: [],
  tourNotes: [],
  tourVaccines: [],
  tourGuides: [],
  tourMealTypes: [],
  tourCities: [],
  tourMeals: [],
  tourDestinations: [],
  tourFocus: [],
  tourActivities: [],
  tourOtherActivities: [],
  tourKilimanjaroInformation: [],
  tourTransports: [],
  airportsTanzania: [],
  airportsTanzaniaInternational: [],
  accomLevels: [],
  accomTypes: [],
  accomLocations: [],
  accomFacilities: [],
  campTypes: [],
};

const getters = {
  tourLevels(state) {
    return state.tourLevels;
  },

  tourNotes(state) {
    return state.tourNotes;
  },

  tourVaccines(state) {
    return state.tourVaccines;
  },

  tourGuides(state) {
    return state.tourGuides;
  },

  tourMealTypes(state) {
    return state.tourMealTypes;
  },

  tourCities(state) {
    return state.tourCities;
  },

  tourMeals(state) {
    return state.tourMeals;
  },

  tourDestinations(state) {
    return state.tourDestinations;
  },

  tourFocus(state) {
    return state.tourFocus;
  },

  tourActivities(state) {
    return state.tourActivities;
  },

  tourOtherActivities(state) {
    return state.tourOtherActivities;
  },

  tourKilimanjaroInformation(state) {
    return state.tourKilimanjaroInformation;
  },

  tourTransports(state) {
    return state.tourTransports;
  },

  airportsTanzania(state) {
    return state.airportsTanzania;
  },

  airportsTanzaniaInternational(state) {
    return state.airportsTanzaniaInternational;
  },

  accomLevels(state) {
    return state.accomLevels;
  },

  accomTypes(state) {
    return state.accomTypes;
  },

  accomLocations(state) {
    return state.accomLocations;
  },

  accomFacilities(state) {
    return state.accomFacilities;
  },

  campTypes(state) {
    return state.campTypes;
  },
};

const mutations = {
  setTourLevels(state, levels) {
    state.tourLevels = levels;
  },

  setTourNotes(state, notes) {
    state.tourNotes = notes;
  },

  setTourVaccines(state, vaccines) {
    state.tourVaccines = vaccines;
  },

  setTourGuides(state, guides) {
    state.tourGuides = guides;
  },

  setTourMealTypes(state, mealTypes) {
    state.tourMealTypes = mealTypes;
  },

  setTourCities(state, cities) {
    state.tourCities = cities;
  },

  setTourMeals(state, meals) {
    state.tourMeals = meals;
  },

  setTourDestinations(state, destinations) {
    state.tourDestinations = destinations;
  },

  setTourFocus(state, focus) {
    state.tourFocus = focus;
  },

  setTourActivities(state, activities) {
    state.tourActivities = activities;
  },

  setTourOtherActivities(state, activities) {
    state.tourOtherActivities = activities;
  },

  setTourKilimanjaroInformation(state, info) {
    state.tourKilimanjaroInformation = info;
  },

  setTourTransports(state, transports) {
    state.tourTransports = transports;
  },

  setAirportsTanzania(state, airports) {
    state.airportsTanzania = airports;
  },

  setAirportsTanzaniaInternational(state, airports) {
    state.airportsTanzaniaInternational = airports;
  },

  setAccomLevels(state, levels) {
    state.accomLevels = levels;
  },

  setAccomTypes(state, types) {
    state.accomTypes = types;
  },

  setAccomLocations(state, locations) {
    state.accomLocations = locations;
  },

  setAccomFacilities(state, facilities) {
    state.accomFacilities = facilities;
  },

  setCampTypes(state, types) {
    state.campTypes = types;
  },
};

const actions = {
  async fetchTourLevels({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/level/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourLevels", res.data);
      });
  },

  async fetchTourNotes({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/note/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourNotes", res.data);
      });
  },

  async fetchTourVaccines({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/vaccine/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourVaccines", res.data);
      });
  },

  async fetchTourGuides({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/guide/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourGuides", res.data);
      });
  },

  async fetchTourMealTypes({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/meal-type/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourMealTypes", res.data);
      });
  },

  async fetchAccomLevels({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/accom-level/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccomLevels", res.data);
      });
  },

  async fetchAccomTypes({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/accom-type/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccomTypes", res.data);
      });
  },

  async fetchAccomLocations({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/accom-location/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccomLocations", res.data);
      });
  },

  async fetchAccomFacilities({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/accom-facility/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAccomFacilities", res.data);
      });
  },

  async fetchCampTypes({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/camp-type/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setCampTypes", res.data);
      });
  },

  async fetchTourCities({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/city/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourCities", res.data);
      });
  },

  async fetchTourMeals({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/meal/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourMeals", res.data);
      });
  },

  async fetchTourDestinations({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/destination/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourDestinations", res.data);
      });
  },

  async fetchTourFocus({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/focus/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourFocus", res.data);
      });
  },

  async fetchTourActivities({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/activity/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourActivities", res.data);
      });
  },

  async createTourActivity({ rootState }, tourActivity) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/tour/activity/create`, tourActivity, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateTourActivity({ rootState }, tourActivity) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/tour/activity/update/${tourActivity.id}`, tourActivity, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteTourActivity({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/tour/activity/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("Selected tour activity deleted successfully!");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async fetchTourOtherActivities({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/other-activity/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourOtherActivities", res.data);
      });
  },

  async fetchTourKilimanjaroInformation({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/kilimanjaro-info/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourKilimanjaroInformation", res.data);
      });
  },

  async fetchTourTransports({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/tour/transport/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setTourTransports", res.data);
      });
  },

  async fetchAirportsTanzania({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/airport/tanzania/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAirportsTanzania", res.data);
      });
  },

  async fetchAirportsTanzaniaInternational({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/airport/international/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setAirportsTanzaniaInternational", res.data);
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
